const AuthLayout = ({ children }) => (
  <div className="auth-page reference-auth">
    <div className="auth-form-side">
      <a href="/" className="back-home" style={{ display: 'inline-flex' }}>
        <i className="fa-solid fa-chevron-left" style={{ fontSize: '.7rem' }} /> Retour à Pass’io
      </a>
      <div className="auth-form-wrap">{children}</div>
    </div>
    <div className="auth-reference-panel">
      <div className="reference-orbits" />
      <i className="fa-solid fa-music note-one reference-note" />
      <i className="fa-solid fa-compact-disc note-two reference-note" />
      <div className="reference-disc">
        <span className="disc-label">P</span>
        <span className="disc-arm" />
      </div>
      <span className="reference-badge">NOW MONITORING</span>
      <div className="reference-copy">
        <h2>Vos royalties, <em>en live.</em></h2>
        <p>Suivez la performance de vos titres et vos revenus Mobile Money en temps réel.</p>
      </div>
      <div className="reference-player">
        <i className="fa-solid fa-backward-step" />
        <b><i className="fa-solid fa-pause" style={{ fontSize: '.8rem' }} /></b>
        <i className="fa-solid fa-forward-step" />
      </div>
    </div>
  </div>
);

export default AuthLayout;
